import { types } from 'mobx-state-tree';
import { BaseEntity } from './BaseEntity';
import { DutyAssignmentForExchangeItem } from './DutyAssignmentForExchangeItem';

export const DutyExchangeItem = types.compose(
  BaseEntity,
  types.model('DutyExchangeItem', {
    dutyExchangeItemId: types.identifierNumber,
    dutyExchangeId: types.integer,
    dutyAssignmentId: types.integer,
    senderId: types.integer,
    recipientId: types.integer,
    sender: types.frozen(),
    recipient: types.frozen(),
    dutyAssignment: DutyAssignmentForExchangeItem,
    requestorName: types.maybe(types.string),
  }),
);
